module.exports = __webpack_public_path__ + "files/7d5fa3e2a370f59774cd189cf6ca2e59.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_SansSerif-Regular.woff2
// module id = 1096
// module chunks = 60